import React from 'react';
import GridMasonry from '../components/GridMasonry';
// import CarouselImage from '../components/CarouselImage';
import Helmet from "react-helmet";
import Aux from '../hoc/Auxiliary';

const images = [
  '../img/fire/IMG-0053.jpg',
  '../img/fire/IMG-0054.jpg',
  '../img/fire/IMG-0055.jpg',
  '../img/fire/IMG-0057.jpg',
];

const Fire = () => (
  <Aux>
    <Helmet>
      <title>Fire</title>
      <meta name="description" content="page fire" />
    </Helmet>
    <GridMasonry images={images} />
  </Aux>
);

export default Fire;
